import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder, UntypedFormGroup, Validators
} from '@angular/forms';

import { StoreService } from 'shared/services/store.service';

@Component({
  selector: 'app-add-favorite',
  templateUrl: './add-favorite.component.html',
  styleUrls: ['./add-favorite.component.scss']
})
export class AddFavoriteComponent implements OnInit {
  form!: UntypedFormGroup;

  formReady = false;

  constructor(
    protected fb: UntypedFormBuilder,
    private storeService: StoreService
  ) { }

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    this.setupForm();
  }

  setupForm(): void {
    this.storeService.setFormReady(this.formReady);

    this.form = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(1)]]
    }, { updateOn: 'blur' });

    this.formReady = true;
    this.storeService.setFormReady(this.formReady);
  }
}
